import { render, staticRenderFns } from "./PrimaryPromotion.vue?vue&type=template&id=d1be694a&scoped=true"
import script from "./PrimaryPromotion.vue?vue&type=script&lang=js"
export * from "./PrimaryPromotion.vue?vue&type=script&lang=js"
import style0 from "./PrimaryPromotion.vue?vue&type=style&index=0&id=d1be694a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1be694a",
  null
  
)

export default component.exports